import { Message, FileAttachment } from "./Message";
import { User, UserSimplified, toUserSimplified } from "./User";

export type RoomItemType = 'link' | 'file' | 'task' | 'officenote' | 'pagecall' | 'memo' | 'folder' | 'ai-memo' | 'ai-minutes'; // Have one model for different types so that only one snapshot listener is required.
export type RoomItemEditable = 'owner-only' | 'everyone';
export type ItemType = 'None' | 'MessageFolder' | 'Message';
//rooms/roomitems
export class RoomItem {
  static COL = 'roomitem';
  id: string = uuid();
  created: Date = new Date();
  updated?: Date = new Date();
  type: RoomItemType = 'link';
  url?: string;
  title?: string;
  text?: string;

  // Normalized: message ID instead of full object
  messageId?: string;
  messagePreview?: string; // Optional: first N chars of message for display

  // Legacy: full message object (for backward compat with existing data)
  message?: Message;

  done: Date | null = null;
  pinned?: boolean = false;
  editableBy?: RoomItemEditable;
  lockedByUserId?: string | null;
  isDataSource?: boolean = false;
  parentId?: string;
  depth?: number = 0;
  file?: FileAttachment;
  storagePath?: string;

  // Minimal user info (for UI display) - use user.id for user ID
  user: UserSimplified;

  // Room ID
  roomId: string;

  constructor(roomId: string, user: User | UserSimplified) {
    this.roomId = roomId;
    this.user = toUserSimplified(user);
  }

  static fromAsItem(item: RoomItem): UIRoomItem {
    const newItem = new UIRoomItem(item);
    if (!item.file && item.message?.files) {
      item.message?.files?.forEach(attachment => {
        if (item.url === attachment.url) {
          newItem.item.file = attachment;
        }
      });
    }

    return newItem;
  }
}

function uuid(): string {
  //uuidv4
  return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function getPCRoomId(itemUrl: string | undefined) {
  if (!itemUrl || !itemUrl.includes('?room_id='))
    return '';
  return itemUrl.split('?room_id=')[1];
}

export class UIRoomItem {
  itemType: ItemType = 'None';
  isChecked: boolean = false;
  isModalChecked: boolean = false;
  isDeletable: boolean = false;
  isMoveable: boolean = false;
  inCart: boolean = false;
  firstItem: UIRoomItem | null = null;
  constructor(public item: RoomItem) {
    if (!item.file && item.message?.files) {
      item.message?.files?.forEach(attachment => {
        if (item.url === attachment.url) {
          item.file = attachment;
        }
      });
    }
  }
}